import { ChartWidgetData } from '../ChartWidget.types';

enum WordCloudWordDirection {
  Mixed = 'Mixed',
  Horizontal = 'Horizontal',
  Vertical = 'Vertical',
  Diagonal = 'Diagonal',
}
const WordCloudWordDirectionByIndex = Object.values(WordCloudWordDirection);

interface WordCloudWidgetData extends Omit<ChartWidgetData, 'generalOptions'> {
  generalOptions: ChartWidgetData['generalOptions'] & {
    /**
     * The direction of the words in the word cloud.
     *
     * Default: 'Horizontal'
     */
    wordDirection?: WordCloudWordDirection;
  };
}

export { WordCloudWordDirection, WordCloudWordDirectionByIndex };
export type { WordCloudWidgetData };
